import Downshift from "downshift";

export const initialState = {
    suggestions: [],
    loading: false,
    noMatches: false,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case "SET_SUGGESTIONS":
            return {
                ...state,
                suggestions: action.suggestions,
                noMatches: action.suggestions.length === 0,
                loading: false,
            };
        case "START_LOADING":
            return {
                ...state,
                loading: true,
                noMatches: false,
            };
        case "HANDLE_ERROR":
            return {
                ...initialState,
                noMatches: true,
            };
        case "CLEAR_STATE":
            return initialState;
        default:
            return state;
    }
};

export const downshiftReducer = (state, changes) => {
    switch (changes.type) {
        case Downshift.stateChangeTypes.blurInput:
            return {
                ...changes,
                inputValue: state.inputValue,
                isOpen: state.isOpen,
            };
        case Downshift.stateChangeTypes.changeInput:
            const hasValue = changes.inputValue.trim();
            return {
                ...changes,
                inputValue: hasValue ? changes.inputValue : "",
            };
        default:
            return changes;
    }
};
